import React from 'react'
import AltaFirmwareForm from 'components/AltaFirmwareForm/AltaFirmwareForm'
import Modal from 'components/Modal/Modal'

const AltaFirmwareModal = ({ open = false, handleClose, onSuccess, selectedOemId, title }) => (
  <Modal open={open} handleClose={handleClose} title={title} fullWidth={false}>
    <AltaFirmwareForm handleClose={handleClose} onSuccess={onSuccess} selectedOemId={selectedOemId} />
  </Modal>
)

export default AltaFirmwareModal
